import React from 'react';
import PropTypes from 'prop-types';

import SharedScript, {
  Contentsquare,
  Ensighten,
  ClickToChat,
  GtagWrapper,
} from '@americanexpress/shared-scripts';
import USConsumerQualtrics from './Qualtrics';

const UsConsumerSharedScripts = ({ children }) => (
  <>
    <Contentsquare version="^1.0.2" />
    <Ensighten version="^1.2.5" />
    <GtagWrapper version="^1.0.0" />
    <USConsumerQualtrics />
    <ClickToChat
      version="^1.0.0"
      market="US"
      locale="en-US"
      lineOfBusiness="personal_acquisition"
    />
    <SharedScript name="dare-clickstream-vars" version="^0.0.7" windowCheck="_dareClickstream" />
    {children}
  </>
);

UsConsumerSharedScripts.propTypes = {
  children: PropTypes.node,
};

UsConsumerSharedScripts.defaultProps = {
  children: null,
};

export default UsConsumerSharedScripts;
